import styled, { css } from 'styled-components'
import { StyledParagraph } from 'components/shared/Typography'
import photo from 'assets/icons/photo.svg'

export const StyledDropzone = styled.div<{ $loading: boolean }>`
  ${({ $loading }) => css`
    padding: 4px 0 20px;
    position: relative;
    cursor: pointer;

    ${$loading &&
    css`
      opacity: 0.8;
      pointer-events: none;
      cursor: not-allowed;
    `}

    .paper {
      margin-left: -30px;
    }
  `}
`

export const DropzoneWrap = styled.div`
  height: 109px;
  background: ${({ theme }) => theme.colors.greySemiLight};
  border-radius: 20px;
  position: relative;
`

export const DropzoneLabel = styled(StyledParagraph)`
  color: ${({ theme }) => theme.colors.greySemiDark};
  padding-left: 24px;
  margin-bottom: 4px;
  display: inline-flex;
  align-items: center;
`

export const EmptyDropzone = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    fill: ${theme.colors.greySemiDark};

    ${StyledParagraph} {
      color: ${theme.colors.greySemiDark};
    }
  `}
`

export const DropzoneFile = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 8px 0 24px;
  position: relative;

  &:after {
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5) url(${photo}) no-repeat center center;
    opacity: 0;
    transition: 0.3s;
  }

  &:hover {
    &:after {
      opacity: 1;
    }
  }
`

export const DropzoneError = styled(StyledParagraph)`
  color: ${({ theme }) => theme.colors.red};
  min-height: 20px;
`

export const InputInfo = styled.span`
  background: ${({ theme }) => theme.colors.greySemiLight};
  width: 16px;
  height: 16px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 4px;
`
